import React from 'react';
import { useSelector } from 'react-redux';
import Pagination from '../shared/table/pagination/Pagination';
import {
  nextUserNotesPageAction,
  prevUserNotesPageAction,
  setUserNotesPageSizeAction,
} from '../../redux/actions/notesActions';

const UserNotesPagination = () => {
  const pageable = useSelector((state) => state.notes?.userNotesPageable);
  return (
    <Pagination
      pageable={pageable}
      onNextPageClickAction={nextUserNotesPageAction}
      onPrevPageClickAction={prevUserNotesPageAction}
      onPageSizeChangeAction={setUserNotesPageSizeAction}
    />
  );
};

export default UserNotesPagination;
